/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfferArticleSummaryResponse } from '../../models/offer-article-summary-response';

export interface GetAllOfferArticles$Params {
  id: number;
}

export function getAllOfferArticles(http: HttpClient, rootUrl: string, params: GetAllOfferArticles$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferArticleSummaryResponse>> {
  const rb = new RequestBuilder(rootUrl, getAllOfferArticles.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OfferArticleSummaryResponse>;
    })
  );
}

getAllOfferArticles.PATH = '/offers/{id}/articles/all';
